import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import OfferTrackerProfileBlock from "./components/OfferTrackerProfileBlock";

import { Container } from "reactstrap";
import {
  getTrackerOfferProfile,
  setErrorTrackerOfferProfile,
  updateTrackerOfferProfile
} from "../../../../store/offers/actions";
import ModifiedMetaTags from '../../../../components/ModifiedMetaTags/index';

class OffersTrackersProfile extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getTrackerOfferProfile(this.props.match.params.trackerId);
  }

  componentWillUnmount() {
    this.props.setErrorTrackerOfferProfile(false);
  }

  render() {
    const data = this.props.data;
    const trackerId = this.props.match.params.trackerId;
    const isError = this.props.isError;

    if (isError) {
      return (
        <Redirect to={"/404"} />
      );
    }

    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Offer tracker profile | Mobihunter" />

          <Container fluid>
            <OfferTrackerProfileBlock data={data}
                                      updateTrackerOfferProfile={this.props.updateTrackerOfferProfile}
                                      history={this.props.history}
                                      trackerId={trackerId}
                                      offerId={this.props.match.params.offerId}
                                      trackerData={this.props.trackerData}
            />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

OffersTrackersProfile.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      trackerId: PropTypes.node,
      offerId: PropTypes.node,
    }).isRequired
  }).isRequired,
  getTrackerOfferProfile: PropTypes.func,
  updateTrackerOfferProfile: PropTypes.func,
  setErrorTrackerOfferProfile: PropTypes.func,
  history: PropTypes.any,
  data: PropTypes.any,
  trackerData: PropTypes.any,
  isError: PropTypes.any,
};

const mapStateToProps = state => ({
  data: state.Offers.profileTrackerData,
  trackerData: state.Offers.dataTrackers,
  isError: state.Offers.is_trackers_error,
});

export default withRouter(
  connect(mapStateToProps, {
    getTrackerOfferProfile,
    updateTrackerOfferProfile,
    setErrorTrackerOfferProfile,
  })(OffersTrackersProfile)
);
